module.exports = "<!--http://www.primefaces.org/primeng/#/calendar-->\r\n<p-calendar [monthNavigator]=\"false\" [maxDate]=\"maxDate\" [yearNavigator]=\"yearNavigator\" yearRange=\"1900:2100\" [showIcon]=\"false\"\r\n  [showOnFocus]=\"true\" [showTime]=\"showTime\" [readonlyInput]=\"true\" [inputStyle]=\"form-control\" [placeholder]=\"placeholder\"\r\n  (onSelect)=\"onSelect($event)\" [locale]=\"es\" dateFormat=\"dd/mm/yy\"></p-calendar>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared/localized-calendar/localized-calendar.component.html
// module id = ../../../../../src/app/shared/localized-calendar/localized-calendar.component.html
// module chunks = 16